import { AppointmentSchedulingConfiguration } from './appointment_scheduling_configuration';

angular
  .module('capability-ng-appointments')
  .service('ngAppointmentSchedulingConfiguration', AppointmentSchedulingConfiguration);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/config/config_module.ts